import { IconButton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback } from 'react';
import { Iconify } from 'src/components/iconify';
import { MOBILE_BREAKPOINT } from 'src/config-global';
import { useNavbarContext } from 'src/provider/NavbarContext';

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    display: 'flex',
  },
  padding: 1,
  color: theme.palette.text.secondary,
}));

export const ExpandCollapseIcon = () => {
  const { hiddenNavBar, setHiddenNavBar } = useNavbarContext();

  const handleToggleNavbar = useCallback(() => {
    setHiddenNavBar(!hiddenNavBar);
  }, [hiddenNavBar, setHiddenNavBar]);

  return (
    <Stack justifyContent="center">
      <IconButtonStyled
        onClick={(e) => {
          handleToggleNavbar();
          e.stopPropagation();
        }}
      >
        <Iconify
          icon={hiddenNavBar ? 'tabler:chevrons-right' : 'tabler:chevrons-left'}
          sx={{
            width: 24,
            height: 24,
          }}
        />
      </IconButtonStyled>
    </Stack>
  );
};
